<template>
  <div v-if="loanData">
    <section class="accent-text-box mb-2">
      <p>모집금액</p>
      <h3 class="amount font-size--24">{{ commaFormat(investingAmount) }}원</h3>
    </section>

    <div class="mb-2 linear-box rounded-3">
      <v-progress-linear
        :value="(investingAmount / loanData.amount) * 100"
        height="24"
        class="rounded-3"
        color="primary"
        background-color="transparent"
      ></v-progress-linear>
    </div>

    <v-layout justify-space-between align-center class="mb-1 font-weight-black">
      <span>신청 금액</span>
      <span>{{ commaFormat(loanData.amount) }}원</span>
    </v-layout>
    <v-layout justify-space-between align-center class="mb-1 font-weight-black">
      <span>모집 금액</span>
      <span>{{ commaFormat(investingAmount) }}원</span>
    </v-layout>

    <LoanContractButton :uuid="uuid" height="40" :classes="['font-weight-black']" />
  </div>
</template>

<script>
import loanPropsMixin from '@/components/loan/loanPropsMixin'
import { commaFormat } from '@/filter/number'
import { mapActions } from 'vuex'

export default {
  mixins: [loanPropsMixin],

  components: {
    LoanContractButton: () => import('@/components/loan/LoanContractButton.vue'),
  },

  data() {
    return {
      investingAmount: null,
    }
  },
  methods: {
    commaFormat,
    ...mapActions('loan', ['getInvestingAmount']),
  },
  async created() {
    this.investingAmount = (await this.getInvestingAmount(this.uuid)) || 0
  },
}
</script>

<style lang="scss" scoped>
.text-box {
  p,
  h3 {
    line-height: 1.2;
  }
}

.linear-box {
  position: relative;
  height: 24px;
  background-color: #eee;
  .v-progress-linear {
    position: absolute;
  }
}
</style>
